import { Stepper } from 'components/UI'
import { approvalActions, territoriesActions } from 'ducks/actions'
import { ApprovalValue } from 'ducks/approval/types'
import { useAppDispatch } from 'ducks/hooks'
import { getApprovalStep, getEstimate } from 'ducks/selectors'
import { useSelector } from 'react-redux'
import Step1SecondaryHomeowner from './Step1/Step1Secondary'
import Step2SecondaryHomeowner from './Step2/Step2Secondary'
import Step3Homeowner from './Step3/Step3'
import { useEffect } from 'react'

const HomeownerSecondApprovalStepper = () => {
  const dispatch = useAppDispatch()
  const activeStep = useSelector(getApprovalStep)


  const estimate = useSelector(getEstimate())

  useEffect(() => {
    if (estimate?.properties?.address?.zipCode)
      dispatch(territoriesActions.fetchTerritory(estimate?.properties?.address?.zipCode))
  }, [estimate])

  const steps = [
    {
      content: <Step1SecondaryHomeowner />,
    },
    {
      content: <Step3Homeowner />,
      disableBack: true,
      // actionNext: () => setIsFinished(true),
    },
  ]



  return (
    <>
      <Stepper
        steps={steps}
        activeStep={activeStep}
        setActiveStepAction={(step: number) =>
          dispatch(approvalActions.setApprovalStep(step))
        }
        saveNewValueAction={(value: ApprovalValue) =>
          dispatch(approvalActions.setApprovalValue(value))
        }
      //className={classes.stepper}
      />
    </>
  )
}

export default HomeownerSecondApprovalStepper
